import { Typography } from "@mui/material";

// Red "*" appended to a required field's label. Inherits the surrounding text variant.
const RequiredFieldMarker = () => (
  <Typography component="span" variant="inherit" color="error">
    &nbsp;*
  </Typography>
);

export default RequiredFieldMarker;
